import type { PropsWithChildren } from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { mqMin, zIndex } from '@sunwebgroup/ui-components'
import { Button } from '@sunwebgroup/ui-components/uds'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

const Content = styled.div`
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${zIndex.modalOrMobilePopover};
  @media ${mqMin('primitives_breakpoint_l_min')} {
    z-index: ${zIndex.popover};
  }
`

export function Dialog({ children }: PropsWithChildren) {
  return (
    <DialogPrimitive.Content asChild>
      <Content>{children}</Content>
    </DialogPrimitive.Content>
  )
}

export function CrossButton() {
  const intl = useIntl()

  return (
    <DialogPrimitive.Close asChild>
      <Button $type="transparentPrimary">{intl.formatMessage({ id: 'close' })}</Button>
    </DialogPrimitive.Close>
  )
}
